import { render, staticRenderFns } from "./dropvspick.vue?vue&type=template&id=8ec79884&"
import script from "./dropvspick.vue?vue&type=script&lang=js&"
export * from "./dropvspick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports